<div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
  <div class="d-flex align-items-center gap-3">
    <div>
      <h5 class="mb-1 fw-bold">Labours</h5>
      <span class="sub-text">Manage labour workforce</span>
    </div>
  </div>

  <div class="d-flex gap-2 align-items-center">
    <button
      (click)="openSalaryRangeModal(salaryRangeDateContent)"
      class="btn btn-soft-primary d-flex align-items-center gap-1">
      <i class="bi bi-download me-1"></i>
      <span>All Labours Salary Sheet</span>
    </button>

    <button class="btn btn-primary btn-enjochem" (click)="openForm()">
      <i class="bi bi-plus-circle"></i>
      Add Labour
    </button>
  </div>
</div>

<!-- Search Filter -->
<div class="row mb-3">
  <div class="col-12 px-0">
    <div class="input-group">
      <span class="input-group-text bg-white border-end-0">
        <i class="bi bi-search text-muted"></i>
      </span>
      <input
        type="text"
        class="form-control border-start-0 ps-0"
        placeholder="Search by name..."
        [(ngModel)]="searchTerm"
        (keyup)="onSearchKeyUp()" />
    </div>
  </div>
</div>

@if (isLaboursDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  @if (laboursList.length === 0) {
    <div class="text-center py-4 text-muted">
      <app-info-alert>
        You can add labour by clicking the
        <strong>Add Labour</strong>
        button.
      </app-info-alert>
    </div>
  } @else {
    <div class="table-responsive">
      <table class="table align-middle">
        <thead class="text-muted">
          <tr>
            <th>Full Name</th>
            <th>Mobile Number</th>
            <th>Type of Labour</th>
            <th>Department</th>
            <th>Warehouse</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let labour of laboursList">
            <td>{{ labour.full_name }}</td>
            <td>{{ labour.mobile_number }}</td>
            <td>{{ labour.type_of_labour }}</td>
            <td>{{ labour.department }}</td>
            <td>{{ labour.warehouse?.name || '-' }}</td>
            <td class="text-center">
              <div class="d-flex justify-content-center align-items-center gap-2 flex-nowrap">
                <button
                  class="btn btn-sm btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
                  (click)="openAdvanceModal(advanceModalContent, labour)"
                  title="Add advance">
                  <i class="bi bi-cash-coin"></i>
                  <span>Add Advance</span>
                </button>
                <button
                  class="btn btn-sm btn-outline-info d-inline-flex align-items-center gap-1 text-nowrap"
                  (click)="viewAdvanceLedger(labour)"
                  title="Advance history ledger">
                  <i class="bi bi-journal-text"></i>
                  <span>Ledger</span>
                </button>
                <button
                  class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1 text-nowrap"
                  (click)="openSingleLabourSalaryModal(labour)"
                  title="Download salary sheet">
                  <i class="bi bi-download"></i>
                  <span>Salary Sheet</span>
                </button>
                <button
                  class="btn btn-sm btn-outline-primary d-inline-flex align-items-center"
                  (click)="openForm(labour)"
                  title="Edit">
                  <i class="bi bi-pencil"></i>
                </button>
                <button
                  class="btn btn-sm btn-outline-danger d-inline-flex align-items-center"
                  (click)="onDeleteLabour(labour)"
                  title="Delete">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  @if (laboursList.length > 0) {
    <div class="mt-4">
      <app-pagination
        [currentPage]="currentPage"
        [totalCount]="totalCount"
        [pageSize]="10"
        [hasNextPage]="hasNextPage"
        [hasPreviousPage]="hasPreviousPage"
        (pageChange)="onPageChange($event)"></app-pagination>
    </div>
  }
}

<ng-template #labourFormModalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Labour Details</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <form [formGroup]="labourForm" (ngSubmit)="submitForm()" enctype="multipart/form-data">
    <div class="modal-body row g-3">
      <!-- Warehouse Dropdown -->
      <div class="col-md-6">
        <label class="form-label">
          Warehouse
          <span class="text-danger">*</span>
        </label>
        <ng-select
          placeholder="Select warehouse"
          [items]="wareHouses"
          formControlName="warehouse_id"
          bindValue="id"
          bindLabel="name"
          [clearable]="false"
          [searchable]="false" />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Full Name
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="full_name" />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Aadhar Number
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="aadhar_number" />
        <span class="sub-text">(e.g. 123456789012)</span>
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Date of Birth
          <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="date_of_birth" />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Gender
          <span class="text-danger">*</span>
        </label>
        <ng-select
          placeholder="Select gender"
          [items]="genderOptions"
          formControlName="gender"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Father/Spouse Name</label>
        <input type="text" class="form-control" formControlName="father_or_spouse_name" />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Mobile Number
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="mobile_number" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Alternate Number</label>
        <input type="text" class="form-control" formControlName="alternate_number" />
      </div>

      <div class="col-md-12">
        <label class="form-label">
          Address
          <span class="text-danger">*</span>
        </label>
        <textarea class="form-control" rows="2" formControlName="address"></textarea>
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Type of Labour
          <span class="text-danger">*</span>
        </label>
        <ng-select
          placeholder="Select type"
          [items]="labourTypeOptions"
          formControlName="type_of_labour"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false" />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Department
          <span class="text-danger">*</span>
        </label>
        <ng-select
          placeholder="Select department"
          [items]="departmentOptions"
          formControlName="department"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false" />
      </div>

      <div class="col-md-6">
        <label class="form-label">
          Date of Joining
          <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="date_of_joining" />
      </div>

      <!-- Salary Fields -->
      <div class="col-md-6">
        <label class="form-label">Daily Wages (₹)</label>
        <input type="number" class="form-control" formControlName="daily_wages" min="0" placeholder="e.g. 500" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Working Hours</label>
        <input type="number" class="form-control" formControlName="working_hours" min="0" placeholder="e.g. 8" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Per Hour Rate (₹)</label>
        <input type="number" class="form-control" formControlName="per_hour_rate" min="0" placeholder="e.g. 62.5" />
      </div>

      <div class="col-md-6">
        <label class="form-label">OT Rate (₹/hr)</label>
        <input type="number" class="form-control" formControlName="ot_rate" min="0" placeholder="e.g. 93.75" />
      </div>

      <div class="col-md-6">
        <label class="form-label">TA Per Day (₹)</label>
        <input type="number" class="form-control" formControlName="ta_per_day" min="0" placeholder="e.g. 100" />
      </div>

      <!-- File Upload -->
      <div class="col-md-6">
        <label class="form-label">Photo ID</label>
        <input type="file" class="form-control" (change)="onFileChange($event)" />
        <div *ngIf="previewUrl" class="mt-2">
          <img [src]="previewUrl" alt="Photo ID" class="img-thumbnail" width="120" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="labourForm.invalid">Save</button>
    </div>
  </form>
</ng-template>

<ng-template #salaryRangeDateContent let-modal>
  <form [formGroup]="salaryRangeForm" (ngSubmit)="getSalaryDetails()">
    <div class="modal-header">
      <h5 class="modal-title">Select Date Range</h5>
      <button type="button" class="btn-close" (click)="modalRef.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <label class="form-label">From Date</label>
          <input type="date" class="form-control" formControlName="from_date" required />
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label">To Date</label>
          <input type="date" class="form-control" formControlName="to_date" required />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancel</button>
      <button type="submit" class="btn btn-primary btn-enjochem" [disabled]="salaryRangeForm.invalid">Get</button>
    </div>
  </form>
</ng-template>

<ng-template #advanceModalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Advances — {{ selectedLabourForAdvance?.full_name }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <!-- Add Advance Form -->
    <form [formGroup]="advanceForm" (ngSubmit)="submitAdvance()">
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <label class="form-label">
            Amount (₹)
            <span class="text-danger">*</span>
          </label>
          <div class="input-group">
            <span class="input-group-text">₹</span>
            <input type="number" class="form-control" formControlName="amount" placeholder="e.g. 500 for deduction" />
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label">
            Date
            <span class="text-danger">*</span>
          </label>
          <input type="date" class="form-control" formControlName="date" />
        </div>

        <div class="col-md-4">
          <label class="form-label">Note</label>
          <input type="text" class="form-control" formControlName="note" placeholder="Optional" />
        </div>
      </div>

      <button type="submit" class="btn btn-primary btn-enjochem btn-sm" [disabled]="advanceForm.invalid">
        <i class="bi bi-plus-circle me-1"></i>
        Add Advance
      </button>
    </form>

    <hr />

    <!-- Advances History -->
    <h6 class="fw-bold mb-3">Advance History</h6>

    @if (isAdvancesLoading) {
      <app-loading-spinner></app-loading-spinner>
    } @else if (advancesList.length === 0) {
      <app-info-alert>No advances recorded for this labour.</app-info-alert>
    } @else {
      <div class="table-responsive">
        <table class="table table-sm align-middle">
          <thead class="text-muted">
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let advance of advancesList">
              <td>{{ advance.date | date: 'mediumDate' }}</td>
              <td>₹{{ advance.amount }}</td>
              <td>{{ advance.note || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>
